module.exports = __webpack_public_path__ + "img/icon Ribs.8dc85307.webp";